// 红黑料 · 单页首页内容数据（虚构示例，仅用于排版演示）

export interface TrendingBrief {
  id: number;
  rank: number;
  title: string;
  summary: string;
  tag: '塌房' | '翻车' | '争议' | '曝光';
  heat: string;
  delta: number;
}

export const trendingBriefs: TrendingBrief[] = [
  {
    id: 1, rank: 1,
    title: '男演员沈棠被曝片场缺席三小时，录音流出引导演组不满',
    summary: '一段片场收音流出，指其在关键戏份中途离场补妆，全组等待，制片方暂未回应。',
    tag: '曝光', heat: '128.6万', delta: 2,
  },
  {
    id: 2, rank: 2,
    title: '女团 PrismX 成员早期言论被考古，争议帖讨论量单日破十万',
    summary: '旧帖截图被翻出，围绕队内关系与对待粉丝态度的两派声音仍在拉扯。',
    tag: '塌房', heat: '104.2万', delta: 1,
  },
  {
    id: 3, rank: 3,
    title: '导演陆镜新作被指多处镜头与旧片高度相似，抄袭疑云发酵',
    summary: '对比剪辑在同好圈疯传，工作室回应称“借鉴皆致敬”，网友并不买账。',
    tag: '争议', heat: '87.3万', delta: 4,
  },
  {
    id: 4, rank: 4,
    title: '头部主播大嘴哥哥年货专场被曝夸大功效，售后仅作口头说明',
    summary: '消费者晒出购买记录与直播间话术对比，平台已介入了解。',
    tag: '翻车', heat: '72.9万', delta: 0,
  },
  {
    id: 5, rank: 5,
    title: '说唱歌手 Milo 巡演被指对口型，收音源让“全开麦”宣传成空话',
    summary: '现场饭拍与官方说法矛盾，主办方称将公开技术参数自证。',
    tag: '塌房', heat: '61.4万', delta: 3,
  },
  {
    id: 6, rank: 6,
    title: '主持人方圆直播口误称品牌为“另一家”，一句玩笑被逐帧放大',
    summary: '澄清视频已发，但“阴阳怪气”玩梗仍在各平台持续二创。',
    tag: '争议', heat: '48.8万', delta: -1,
  },
  {
    id: 7, rank: 7,
    title: '网红阿噗农家乐测评被扒是摆拍，导演组分镜截图成实锤',
    summary: '“随机探店”沦为剧本，评论区要求退还此前合作商单费用。',
    tag: '翻车', heat: '39.1万', delta: 2,
  },
  {
    id: 8, rank: 8,
    title: '偶像许也生日应援被曝倒卖周边，站姐与后援会各执一词',
    summary: '应援周边流向二手平台被粉丝发现，内部聊天记录真假难辨。',
    tag: '曝光', heat: '33.5万', delta: -2,
  },
  {
    id: 9, rank: 9,
    title: '团体“北岸少年”解散一周年，成员退出内幕又被重新提起',
    summary: '旧采访被翻出，多名成员当年采访中“未说出口的话”成为新谈资。',
    tag: '塌房', heat: '27.6万', delta: 1,
  },
  {
    id: 10, rank: 10,
    title: '品牌轻盏茶联名文案被指影射竞品，官微连夜换图删博',
    summary: '夹带私货的营销文案被广告圈逐条拆解，声明已发但热度不减。',
    tag: '争议', heat: '21.9万', delta: -3,
  },
];

export interface FeaturedExposure {
  id: number;
  kicker: string;
  title: string;
  summary: string;
  image: string;
  tag: string;
  reads: string;
  comments: string;
  evidence: string;
}

export const featuredExposures: FeaturedExposure[] = [
  {
    id: 1,
    kicker: '封面大瓜 · 片场实录',
    title: '录音流出：沈棠被指“半途离场”，一场等待背后的剧组账单',
    summary:
      '三段共 9 分钟的片场录音流出，指向某热门剧集拍摄期间主演多次中途离场。我们把录音时间线、在场群演侧写与剧组通告单逐段对齐，试图还原一场“集体等待”的真实成本——人力、档期，以及那句一直没被正面回应的道歉。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20dim%20backstage%20film%20set%20with%20empty%20director%20chairs%20and%20tangled%20cables%20under%20a%20single%20cold%20spotlight%2C%20scattered%20script%20pages%20and%20a%20faint%20red%20warning%20glow%20in%20the%20dark%20corner%2C%20cinematic%20editorial%20photography%2C%20high%20contrast%2C%20mysterious%20and%20dramatic%20atmosphere&width=1280&height=854&seq=feature-lead-01&orientation=landscape',
    tag: '片场黑料',
    reads: '36.8万阅读',
    comments: '2.1万讨论',
    evidence: '录音 3 段 · 通告单 1 份',
  },
  {
    id: 2,
    kicker: '黑料曝光',
    title: '旧帖考古：PrismX 早期言论被扒，饭圈一夜“破防”',
    summary: '多年前的社交发言截图被系统性整理，涉及队内关系与对待粉丝的态度。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20still%20life%20of%20scattered%20old%20smartphone%20screens%20and%20crumpled%20letters%20on%20a%20worn%20wooden%20desk%20lit%20by%20faint%20red%20neon%20light%2C%20social%20media%20archive%20collage%2C%20dramatic%20editorial%20photography%2C%20mysterious%20investigative%20mood&width=800&height=600&seq=feature-card-02&orientation=landscape',
    tag: '塌房考古',
    reads: '18.4万阅读',
    comments: '0.9万讨论',
    evidence: '截图 46 张 · 时间线 1 份',
  },
  {
    id: 3,
    kicker: '争议事件',
    title: '镜头高度相似：导演陆镜的“借鉴”，究竟借到了哪一步',
    summary: '逐帧对比视频走红后，我们从分镜、机位与剪辑节奏三维度拆解相似度。',
    image: 'https://readdy.ai/api/search-image?query=Dim%20cinema%20editing%20suite%20with%20split%20screen%20storyboard%20monitors%20glowing%20in%20red%20and%20black%20light%2C%20film%20reels%20and%20a%20clapperboard%20on%20the%20desk%2C%20dramatic%20moody%20editorial%20photography%2C%20cinematic%20investigative%20atmosphere&width=800&height=600&seq=feature-card-03&orientation=landscape',
    tag: '争议盘点',
    reads: '12.1万阅读',
    comments: '0.6万讨论',
    evidence: '对比片段 3 组 · 分镜稿 1 份',
  },
  {
    id: 4,
    kicker: '翻车现场',
    title: '“全网最低价”失灵：直播间话术与到手价的逐项对账',
    summary: '消费者把直播录屏、下单记录与售后截图并排，价格与功效的出入被逐条列出。',
    image: 'https://readdy.ai/api/search-image?query=Product%20boxes%20scattered%20across%20a%20studio%20floor%20under%20harsh%20flash%20photography%2C%20a%20cracked%20ceramic%20mug%20and%20spilled%20objects%2C%20red%20warning%20tone%20lighting%2C%20chaotic%20editorial%20commercial%20still%20life%2C%20documentary%20mood&width=800&height=600&seq=feature-card-04&orientation=landscape',
    tag: '带货翻车',
    reads: '9.7万阅读',
    comments: '0.4万讨论',
    evidence: '录屏 12 段 · 订单 21 单',
  },
];

export interface CrashMilestone {
  id: number;
  date: string;
  actor: string;
  title: string;
  summary: string;
  state: '已回应' | '发酵中' | '已反转' | '冷处理';
  refs: string;
}

export const crashTimeline: CrashMilestone[] = [
  {
    id: 1,
    date: '2026.09.03',
    actor: '沈棠',
    title: '片场缺席录音流出',
    summary: '收音源最早出现在匿名帖，随后被多名影视区博主转发，导演组、制片方均被喊话。',
    state: '发酵中', refs: '引用源 4 · 音频 3',
  },
  {
    id: 2,
    date: '2026.08.29',
    actor: 'Milo',
    title: '巡演“全开麦”被打脸',
    summary: '饭拍音频与音源软件比对结果公开，官方称将公布技术参数，隔天却悄悄撤档。',
    state: '已反转', refs: '引用源 6 · 频谱 2',
  },
  {
    id: 3,
    date: '2026.08.21',
    actor: '大嘴哥哥',
    title: '年货专场功效夸大',
    summary: '多款商品功效与检测报告不符，市场监管部门已收到书面投诉，商家称积极配合。',
    state: '已回应', refs: '引用源 9 · 投诉单 5',
  },
  {
    id: 4,
    date: '2026.08.12',
    actor: '轻盏茶',
    title: '联名文案“夹带私货”',
    summary: '影射竞品的段落被广告圈逐句拆解，官微连夜换图删博后发布无署名致歉。',
    state: '冷处理', refs: '引用源 5 · 原文存档',
  },
  {
    id: 5,
    date: '2026.07.30',
    actor: '北岸少年',
    title: '解散内幕被重新提起',
    summary: '旧采访中成员“话里有话”的段落被重新剪辑，退出原因再成舆论焦点。',
    state: '发酵中', refs: '引用源 3 · 采访 2',
  },
];

export interface ArchiveGenre {
  id: number;
  name: string;
  desc: string;
  count: number;
  icon: string;
  tag: string;
}

export const archiveGenres: ArchiveGenre[] = [
  { id: 1, name: '言语塌房', desc: '失言、喊话、旧帖考古，说话的艺术在这里翻车', count: 32, icon: 'ri-chat-voice-line', tag: '嘴瓢' },
  { id: 2, name: '商务塌房', desc: '代言、商单、价格与功效，合作翻车集散地', count: 27, icon: 'ri-handbag-line', tag: '带货' },
  { id: 3, name: '私德塌房', desc: '绯闻、品行、人前人后，滤镜碎掉的时刻', count: 41, icon: 'ri-user-heart-line', tag: '品行' },
  { id: 4, name: '舞台塌房', desc: '假唱、罢演、设备事故，聚光灯下的翻车', count: 18, icon: 'ri-mic-line', tag: '演出' },
  { id: 5, name: '团队塌房', desc: '解散、出走、站队，团魂瓦解全程记录', count: 22, icon: 'ri-group-line', tag: '内斗' },
  { id: 6, name: '数据塌房', desc: '票房、销量、热度，注过水的数字都会漏', count: 16, icon: 'ri-bar-chart-2-line', tag: '造假' },
];

export interface ControversyItem {
  id: number;
  number: string;
  title: string;
  focus: string;
  views: string[];
  trend: string;
}

export const controversyItems: ControversyItem[] = [
  {
    id: 1, number: '01',
    title: '录音流出，先谈“真假”还是先谈“教养”？',
    focus: '焦点在证据链：音频未经剪辑验真，但话术本身已足以引发公众情绪。',
    views: ['支持者：行为应验后道歉', '反对者：证据未实锤勿定罪', '路人：等一个官方说法'],
    trend: '讨论量持续走高',
  },
  {
    id: 2, number: '02',
    title: '考古旧帖翻车，是“人设崩塌”还是“成长宽容”？',
    focus: '多年前言论被放大，网络记忆与“人非圣贤”两种逻辑正面交锋。',
    views: ['正方：言行一致是底线', '反方：给成长留余地', '中立：看是否仍然在用'],
    trend: '两派对半开',
  },
  {
    id: 3, number: '03',
    title: '“借鉴”与“抄袭”的边界，到底谁来划线？',
    focus: '镜头语言相似能否构成侵权，业界惯例与大众直觉存在明显温差。',
    views: ['法律视角：需逐帧比对', '行业视角：创作惯例', '观众视角：观感最重要'],
    trend: '专业解读上热搜',
  },
  {
    id: 4, number: '04',
    title: '带货翻车后，责任归主播还是归品牌？',
    focus: '佣金与选品责任切割模糊，一场事故把“谁为货品兜底”推上桌面。',
    views: ['消费者：主播要选品', '品牌方：全程不知情', '平台：规则在完善'],
    trend: '监管话题被带热',
  },
  {
    id: 5, number: '05',
    title: '解散后旧料重提，是“消费旧账”还是“补全真相”？',
    focus: '当年“未说出口的话”重见天日，真相与流量的边界难以说清。',
    views: ['粉丝：给个正式交代', '媒体：档案有存档价值', '路人：吃瓜就看热闹'],
    trend: '怀旧与质疑并行',
  },
];

export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 1,
    q: '红黑料的内容可信吗？素材从哪里来？',
    a: '每一条进入页面的料都会标注素材性质——录音、截图、录屏或引用源，并在卡片上注明“引用源数量”。我们只做整理与排序，把原素材摆在明面上，观点与事实分开呈现，方便你自己判断可信度。',
  },
  {
    id: 2,
    q: '更新频率是怎样的？今天的热榜是实时吗？',
    a: '热榜与速递按事件热度滚动更新，通常在事件发酵数小时内完成收录与打标；塌房合集与争议盘点则按周归档，保证档案可回溯、可检索。',
  },
  {
    id: 3,
    q: '涉及当事人，会有“反转”后如何更正？',
    a: '每起事件的卡片上都带状态标签：发酵中 / 已回应 / 已反转 / 冷处理。一旦当事人提供可信回应或证据，我们会第一时间更新状态并在时间轴补一条更正记录，避免“一锤定音”。',
  },
  {
    id: 4,
    q: '会被要求删帖或收到律师函吗？如何处理存疑信息？',
    a: '对仍存疑、未验真的素材，我们一律标注“待核实”而不下结论。当事人可通过内容页的申诉入口提出异议，核实后将按事实更新或下架，坚持“先验真、再定性”的原则。',
  },
  {
    id: 5,
    q: '本页出现的艺人与事件是真实发生的吗？',
    a: '本单页为排版演示用途，文中涉及的人物、团体、品牌与事件均为虚构示例，仅用于展示内容版式与栏目结构，不对应任何现实中的个人或组织。',
  },
];

export const heatTags = ['塌房合集', '黑料曝光', '负面事件', '黑历史', '翻车现场', '争议事件'];

export const tickerNews: string[] = [
  '沈棠片场缺席录音持续发酵，导演组被喊话回应',
  'PrismX 旧帖考古单日新增 8 万讨论',
  '大嘴哥哥年货专场被市场监管点名关注',
  '北岸少年解散旧料重上热榜',
  '轻盏茶联名文案翻车后已删除致歉',
];